"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnExpand = void 0;
var react_1 = require("react");
var useOnExpand = function (
/** Value from Option. Accepts an array of any content */
value) {
    var getValue = Array.isArray(value) ? value : [value];
    var _a = react_1.useState(__spreadArrays(getValue)), expandValue = _a[0], setExpandValue = _a[1];
    var setCollapseValue = function (data) {
        expandValue.includes(data)
            ? setExpandValue(function (prevState) {
                return __spreadArrays(prevState).filter(function (item) { return item !== data; });
            })
            : setExpandValue(function (prevState) { return __spreadArrays(prevState, [data]); });
        return expandValue;
    };
    return [expandValue, setCollapseValue];
};
exports.useOnExpand = useOnExpand;
//# sourceMappingURL=useOnExpand.js.map